var React = require('react');

function ExclamationMark (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"m67.5 5h-35c-4.5 0-7.6016 4.5-6 8.6992l14 39.801c0.89844 2.5 3.3008 4.1992 6 4.1992h7c2.6992 0 5.1016-1.6992 6-4.1992l14-39.801c1.5-4.1992-1.6016-8.6992-6-8.6992z","key":0}),React.createElement("path",{"d":"m64.398 80.602c0 7.9531-6.4453 14.398-14.398 14.398s-14.398-6.4453-14.398-14.398c0-7.9531 6.4453-14.402 14.398-14.402s14.398 6.4492 14.398 14.402","key":1})]));
}

ExclamationMark.defaultProps = {"width":"100%","height":"100%","version":"1.1","viewBox":"0 0 100 100"};

module.exports = ExclamationMark;

ExclamationMark.default = ExclamationMark;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/exclamation-mark.svg
// module id = 387
// module chunks = 0